up.compiler('.sign-language-plea-form', function() {
  const fragmentLoaded = up.on('up:fragment:loaded', function({ response, renderOptions }) {
    const reloadTarget = response.header('X-Reload-On-Accept')
    if (reloadTarget) {
      renderOptions.onAccepted = () => up.reload(reloadTarget)
    }
  })

  return [fragmentLoaded]
})
